import Svg, {Defs, Mask, Rect} from "react-native-svg";

type Props = {
    x: number,
    y: number,
    width: number,
    height: number,
}

export default function SvgRectMask({x, y, width, height}: Props) {
    return (
        <Svg height="100%" width="100%">
            <Defs>
                <Mask id="mask" x="0" y="0" height="100%" width="100%">
                    <Rect height="100%" width="100%" fill="#fff"/>
                    <Rect x={x} y={y} height={height} width={width} fill="black"/>
                </Mask>
            </Defs>
            <Rect height="100%" width="100%" fill="rgba(0, 0, 0, 0.5)" mask="url(#mask)"/>
        </Svg>
    );
}